export default {
    'name': 'magnifier',
    'width': '12',
    'height': '12',
    'viewBox': '0 0 12 12',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M2 5.4375C2 3.53902 3.53902 2 5.4375 2C7.33598 2 8.875 3.53902 8.875 5.4375C8.875 7.33598 7.33598 8.875 5.4375 8.875C3.53902 8.875 2 7.33598 2 5.4375ZM5.4375 1C2.98674 1 1 2.98674 1 5.4375C1 7.88826 2.98674 9.875 5.4375 9.875C6.48267 9.875 7.44344 9.51366 8.20172 8.9091L10.1462 10.8536C10.3415 11.0489 10.6581 11.0489 10.8533 10.8536C11.0486 10.6583 11.0486 10.3418 10.8533 10.1465L8.90886 8.20202C9.51357 7.4437 9.875 6.48281 9.875 5.4375C9.875 2.98674 7.88826 1 5.4375 1Z\' fill=\'#42A463\'/>'
}
